export const LOG_IN = {
  REMEMBER_ME: {
    TH: 'จดจำในระบบ',
    EN: 'Remember me'
  },
  USERNAME: {
    TH: 'ชื่อผู้ใช้',
    EN: 'Username'
  },
  PASSWORD: {
    TH: 'รหัสผ่าน',
    EN: 'Password'
  },
  MEMBER_LOGIN: {
    TH: 'เข้าสู่ระบบสมาชิก',
    EN: 'Member Login'
  },
  WELCOME_BACK_SUB: {
    TH: 'กรุณาระมัดระวังในการพิมพ์ข้อมูล',
    EN: 'Please take care when you type your information.'
  },
  FORGOT_PASSWORD: {
    TH: 'ลืมรหัสผ่าน',
    EN: 'Forgot your password?'
  },
  HERE: {
    TH: 'คลิกที่นี่',
    EN: 'HERE'
  },
  SIGN_IN: {
    TH: 'ลงชื่อเข้าใช้',
    EN: 'Sign in'
  },
  LOGIN_GOOGLE: {
    TH: 'เชื่อมต่อบัญชีกูเกิล',
    EN: 'Login with Google'
  },
  LOGIN_MICROSOFT: {
    TH: 'เชื่อมต่อบัญชีไมโครซอฟต์',
    EN: 'Login with Microsoft Team'
  },
}

export const RESET_PASSWORD = {
  TITLE: {
    TH: 'รีเซ็ตรหัสผ่าน',
    EN: 'Reset your password'
  },
  SUBTITLE: {
    TH: 'ทำการใส่รหัสผ่านในการเข้าถึงผู้ใช้ของท่าน',
    EN: 'Choose a new password to finish signing in.'
  },
  TITLE_COMPLETE: {
    TH: 'รีเซ็ตรหัสผ่านสำเร็จ',
    EN: 'Password Change Complete!'
  },
  SUBTITLE_COMPLETE: {
    TH: 'ท่านได้ทำการเปลี่ยนรหัสผ่านของท่าน เรากำลังนำพาท่านเข้าสู้ระบบ',
    EN: 'Your password has been changed, and you have been logged into your account.'
  },
  PASSWORD: {
    TH: 'ใส่รหัสผ่าน',
    EN: 'New password'
  },
  CONFIRM_PASSWORD: {
    TH: 'ใส่รหัสอีกครั้ง',
    EN: 'Re-enter new password'
  },
  SAVE_PASSWORD: {
    TH: 'บันทึกรหัสผ่าน',
    EN: 'Save Password'
  },
  INCORRECT_PASSWORD: {
    TH: 'กรุณาระบุรหัสผ่านและยืนยันรหัสผ่าน',
    EN: 'Please enter a valid password and re-enter password'
  },
  INCORRECT_NEW_PASSWORD: {
    TH: 'กรุณาระบุรหัสผ่าน',
    EN: 'Please enter a valid password',
  },
  INCORRECT_CONFIRM_PASSWORD: {
    TH: 'กรุณาระบุยืนยันรหัสผ่าน',
    EN: 'Please enter a valid re-enter password',
  },
  INCORRECT_CONDITION_PASSWORD: {
    TH: 'กรุณาตรวจสอบเงื่อนไขการตั้งรหัสผ่านด้านล่าง',
    EN: 'Please check the password requirements below.',
  },
  PASSWORD_MISMATCH: {
    TH: 'รหัสผ่านไม่ตรงกัน',
    EN: 'Passwords do not match.',
  },
  RANGE_PASSWORD: {
    TH: 'จำนวนตัวอักษรของรหัสผ่านต้องไม่น้อยกว่า 6 ตัวอักษรและระบุได้ ไม่เกิน 16 ตัวอักษร',
    EN: 'Please specify a password between 6-16 characters',
  },
  UPPER_CASE_PASSWORD: {
    TH: 'ตัวอักษรพิมพ์ใหญ่ (A-Z)',
    EN: 'Upper case letter (A-Z)',
  },
  LOWER_CASE_PASSWORD: {
    TH: 'ตัวอักษรพิมพ์เล็ก (a-z)',
    EN: 'Lower case letter (a-z)',
  },
  NUMBER_PASSWORD: {
    TH: 'ตัวเลข (0-9)',
    EN: 'Number (0-9)',
  },
  SPECIAL_CHARACTER_PASSWORD: {
    TH: 'อักขระพิเศษ (*@#$_!)',
    EN: 'Special character (*@#$_!)',
  },
  PASSWORD_CONDITION_TITLE: {
    TH: 'รหัสผ่านของคุณต้องประกอบด้วย:',
    EN: 'Your password must contain :'
  }
}

export const SET_PASSWORD = {
  TITLE: {
    TH: 'ยินดีต้อนรับเข้าสู่ ',
    EN: 'Welcome to '
  },
  SUBTITLE: {
    TH: 'กรุณาตั้งค่ารหัสผ่าน',
    EN: 'Please set your password'
  },
  TITLE_COMPLETE: {
    TH: 'ตั้งค่ารหัสผ่านสำเร็จ',
    EN: 'Set your password Complete!'
  },
  SUBTITLE_COMPLETE: {
    TH: 'ตั้งค่ารหัสผ่านของคุณเสร็จแล้วและคุณสามารถเข้าสู่ระบบได้',
    EN: 'Your password has been set and you are able to login.'
  },
  PASSWORD: {
    TH: 'รหัสผ่าน',
    EN: 'Set password'
  },
  CONFIRM_PASSWORD: {
    TH: 'ยืนยันรหัสผ่าน',
    EN: 'Confirm  password'
  },
}

export const LOGIN_TYPE = {
  GOOGLE: 'GOOGLE',
  MICROSOFT: 'MICROSOFT',
  USERNAME: 'USERNAME'
}
